import { App, createAppRouter } from '@numistic/app'
import { createHttpDataClient, createQueryClient } from '@numistic/data'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './styles.css'

const origin = window.location.origin
const router = createAppRouter({
  dataClient: createHttpDataClient({ origin, baseUrl: `${origin}/api` }),
  queryClient: createQueryClient(),
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App router={router} />
  </StrictMode>,
)
